import { createSignal } from '@verclam/pulsar';

/** `null` while the import panel is closed; otherwise the preparation the document joins, or `null` for the dossier alone. */
export type ImportDocumentSidebarState = { readonly preparationId: number | null } | null;

const importDocumentSidebarSignal = createSignal<ImportDocumentSidebarState>(null);

export const openImportDocumentSidebar = (preparationId: number | null = null): void => {
	importDocumentSidebarSignal.value = { preparationId };
};

export const closeImportDocumentSidebar = (): void => {
	importDocumentSidebarSignal.value = null;
};

export default importDocumentSidebarSignal;
